export const trimOrEmpty = (value?: string | null) =>
  (value ?? "").trim();

export const normalizeSortString = (value?: string | null) =>
  trimOrEmpty(value).toLowerCase();
